module.exports = __webpack_public_path__ + "static/media/location9.35abe87f.webp";